export const OCR_FEATURE_KEY = 'ocr_analysis'

/** Matches django osapi.wallet.models.PRODUCT_TITLE_SECURITY_AUDITING */
export const WALLET_PRODUCT_TITLE_AUDIT_TRAIL = 'Audit Trail'
